import React from 'react';

const SmsViewContext = React.createContext({
  save: {},
});

export default SmsViewContext;
